import React from 'react';
// import { ICompanyEnv } from './types';

// const config: ICompanyEnv = {
const config = {
    _company: 'yljz',
    baseName: 'FinAuth',
    // todo： 待补充 公网安备
    footer: <React.Fragment>
        <p style={{ color: '#999', width: '100%' }}>© 2024-{(new Date()).getFullYear()} 原力金智（重庆）科技有限公司 版权所有 | <a style={{ color: 'inherit' }} target="_blank" href="https://beian.miit.gov.cn">渝ICP备2024043961号-1</a></p>
    </React.Fragment>,
    logoImg: <img style={{ height: 34, width: 120 }} src={require('image/logo-fin-auth.png')} alt="" />, // NotFound 页面
    logoLink: <a href="/product/finauth" className="logo">
        <img style={{ height: 34, width: 120 }} src={require('image/logo-fin-auth.png')} />
    </a>,
    showNavMenu: false,
    languageLink: 'https://yljz.com/',
    showConcatUs: false,
    documentLink: 'https://global.yljz.com/document/finauth-guide-docs/PRO-App-Authentication',
};

export default Object.freeze(config);



// WEBPACK FOOTER //
// ./src/envcompany/envyljz.jsx